<template>
  <div class="fmCloud" @mousemove.prevent="selectItems" @contextmenu.prevent="showMenu($event)">
    <div class="fixed-top" :style="`width:${$store.state.appRightWidth}px`">
      <TabList
        ref="tabList"
        :placeholder="$t('share.sharePlaceholder')"
        curId="1"
        @setNav="setNav"
        @searchList="searchList"
      ></TabList>
      <div class="file-type">
        <div class="search-result" v-if="shareParams.keywords == ''">
          <el-tooltip
            class="item r-tooltip"
            effect="dark"
            :content="$t('share.allShare')"
            placement="top"
          >
            <span class="all" style="font-weight: 500" @click="resetRouter"
              >{{ $t('share.allShare') }}</span
            >
          </el-tooltip>
          <div class="total">
            {{ total }}
          </div>
        </div>
        <div class="search-result" v-if="shareParams.keywords !== ''">
          <el-tooltip
            class="item r-tooltip"
            effect="dark"
            :content="$t('share.allShare')"
            placement="top"
          >
            <span class="all" @click="resetRouter">{{ $t('share.allShare') }}</span>
          </el-tooltip>
          <div class="r-search">
            <svg-btn icon-class="icon-file-direction" />
             <div class="r-search-tit">
              {{$utils.searchTitSlice(shareParams.keywords)}}
            </div>
          </div>
        </div>

        <div class="fileClass">
          <div class="multiple-operation" v-if="checkedShares.length > 0">
            <div @click="isCancelShare()">
              <svg-btn icon-class="icon-share3" />
              <span> {{ $t(`share.cancelShare`) }}</span>
            </div>
          </div>
          <div class="screenBt">
            <svg-btn class="screen" icon-class="icon-cloud-screen" />
            <div class="floatBox">
              <div class="title">添加筛选条件</div>
              <div class="content">
                <div
                  v-for="item in fileType"
                  @click="chageClass(item.id)"
                  :key="item.id"
                  class="box"
                >
                <svg-btn
                    class="icon_checks"
                    :icon-class="
                      item.id == fileTypeId 
                        ? 'icon-file-check'
                        : 'icon-file-uncheck-' + $store.state.theme"
                  ></svg-btn>
                  <span>{{ $t(item.name) }}</span>
                </div>
              </div>
            </div>
            <!-- 为了适配悬浮而创建的子类 -->
            <div class="lineTips"></div>
          </div>
          <div class="screenBt" style="margin-right: 4px">
            <svg-btn class="screen" icon-class="icon-option" />
            <div class="screenBox">
              <div
                @click="changeSort(item.id)"
                v-for="item in screenList"
                :key="item.id"
                :class="{
                  curScreen: item.id == screenId || item.id1 == screenId
                }"
              >
                <svg-btn icon-class="icon-cloud-check" />
                <span>{{ item.name }}</span>
              </div>
            </div>
            <!-- 为了适配悬浮而创建的子类 -->
            <div class="lineTips"></div>
          </div>
          <span class="line"></span>
          <fm-button
            class="icon-refresh"
            @click="refresh"
            icon="icon-refresh"
            type="info"
            text
            size="small"
          ></fm-button>
        </div>
      </div>
    </div>
    <div
      class="file-content"
      v-infinite-scroll="getShareList"
      ref="scrollBox"
      infinite-scroll-distance="50"
      infinite-scroll-immediate="false"
      @scroll="scrollBoxFun()"
      v-loading="loading"
      @mousedown="handleMouseDown($event, -1)"
      @mouseup.prevent="endSelection"
    >
      <div class="tab-th" v-show="total != 0">
        <div class="selectAll">
          <div @click="allCheck == 2 ? cancelCheckedVal() : setCheckedVal()">
            <svg-btn
              :icon-class="
                allCheck == 2
                  ? 'icon-file-check'
                  : allCheck == 0
                  ? 'icon-file-uncheck-'+$store.state.theme
                  : 'icon-file-checks'
              "
            >
            </svg-btn>
          </div>
          <span>{{ $t('cloud.fileName') }}</span>
        </div>
        <!-- 浏览和下载 表头 -->
        <div class="lineup2" style="width: 108px;cursor: auto;">
          <span>{{$t('cloud.browseDown')}}</span>
        </div>

        <!-- 大小 表头 -->
        <div
          class="lineup2"
          @click="changeSort(screenId == 2 ? 3 : 2)"
        >
          <span>{{ $t('cloud.size') }}</span>
          <img
            v-show="screenId == 2 || screenId == 3"
            :src="
              screenId == 2
                ? $utils.getPng('web4/icon_order_descending')
                : $utils.getPng('web4/icon_order_ascending')
            "
          />
        </div>
        
        <!-- 创建时间 表头 -->
        <div
          class="lineup3"
          @click="changeSort(screenId == 0 ? 1 : 0)"
        >
          <span>{{ $t('cloud.creatTime') }}</span>
          <img
            v-show="screenId == 0 || screenId == 1"
            :src="
              screenId == 0
                ? $utils.getPng('web4/icon_order_descending')
                : $utils.getPng('web4/icon_order_ascending')
            "
          />
        </div>
      </div>
      <div class="file-list" v-if="shareList.length > 0">
        <div
          class="file-item-hover"
          v-for="(item, index) in shareList"
          :key="index"
          @mousedown="handleMouseDown($event, index)"
          @mouseenter="handleMouseenter($event, index)"
          @mouseleave="handleMouseleave($event, index)"
          :class="[
            { hoverItem: item.isHover || checkedShares.indexOf(index) > -1 },
          ]"
          @dblclick="viewUrl(item)"
        >
          <a-dropdown :trigger="dropdown" @visibleChange="visibleChange">
            <div class="file-item" :class="{'lockeditem':item.is_locked=='1'}">
              <div class="lineup1">
                <div class="icon_checks" @dblclick.stop>
                  <svg-btn
                    class="icon_checks"
                    @click.prevent="chooseFile(index)"
                    :icon-class="
                      checkedShares.indexOf(index) > -1
                        ? 'icon-file-check'
                        : 'icon-file-uncheck-'+$store.state.theme
                    "
                  ></svg-btn>
                </div>
              <div class="openFoldername">
                <div class="file_icon">
                  <img class="icon" @error="onError($event, item)"
                  :src="item.showPlay ? item.ext_icon : $utils.fileIcon(item.extension)"/>
                </div>
                <el-tooltip open-delay="1000" popper-class="item list-tooltip" effect="dark" :content="`${item.name}${item.extension?item.extension :''}`" placement="bottom">
                  <span class="name">{{ item.file_name }}{{ item.extension }}</span>
                </el-tooltip>
              </div>
                <div class="locked-info" v-show="item.is_locked == '1'">
                  <svg-btn icon-class="icon-tips-warning" />
                  <span>已锁定 </span>
                </div>
              </div>
              <div class="tools-box" v-if="item.isHover || checkedShares.indexOf(index) > -1 || hoverIndex === index">
                <div @dblclick.stop class="itemFilesTools" v-show="checkedShares.length < 2">
                  <template>
                    <div class="act" v-show="item.is_locked != '1'" @click.stop="viewUrl(item)">
                      <el-tooltip open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="查看"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-view"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div class="act" v-show="item.is_locked != '1'" @click.stop="copyUrl(item)">
                      <el-tooltip open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="复制"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-share2"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div class="act" v-show="item.is_locked != '1'" @click.stop="openShareBox(item)">
                      <el-tooltip open-delay="1000"
                        popper-class="item list-tooltip"
                        effect="dark"
                        content="分享"
                        placement="bottom"
                      >
                        <svg-btn icon-class="icon-share1"></svg-btn>
                      </el-tooltip>
                    </div>
                    <div class="act">
                      <el-dropdown placement="bottom-start"
                        @visible-change="changeVisible($event, item)"
                        @command="(command) => handleCommand(command, item)"
                      >
                        <div>
                          <svg-btn icon-class="icon-cloud-more"></svg-btn>
                        </div>
                        <el-dropdown-menu
                          class="moreAct"
                          slot="dropdown"
                          :class="isOpen ? '' : 'isOpen1'"
                        >
                          <el-dropdown-item command="a"
                            ><span>{{ $t(`share.cancelShare`) }}</span></el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </template>
                </div>
              </div>
              <div style="width: 36px;" v-else></div>

              <!-- 浏览和下载 列表 -->
              <div class="lineup2">{{item.show_view_down_model}}</div>
              
              <!-- 大小 列表 -->
              <div class="lineup2">{{item.size}}</div>

              <!-- 创建时间 列表 -->
              <div class="lineup3">{{item.file_time}}</div>
            </div>
            <template #overlay>
              <a-menu class="menu-a" @contextmenu.prevent v-if="isOpen" :class="isOpen2 ? 'menu-b':''">
                <a-menu-item v-show="!isSelectMore && item.is_locked=='0'"
                  @click="rightHandle(menu_item.id, item)"
                  v-for="menu_item in list1"
                  :key="menu_item.id"
                  :class="menu_item.id == -1 ? 'line' : 'me-item'"
                  >{{ $t(menu_item.name) }}
                </a-menu-item>
                <a-menu-item  @click="rightHandle(6, item)"  class="me-item"> 
                  {{ $t(`share.cancelShare`) }}
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
        </div>
        <div
          v-show="showFlag == 1"
          class="selection-box"
          :style="{
            left: selectionBox.left + 'px',
            top: selectionBox.top + 'px',
            width: selectionBox.width + 'px',
            height: selectionBox.height + 'px',
          }"
        ></div>
        <div class="isOver" v-if="isLoading2" v-loading="isLoading2"></div>

        <div class="isOver" v-if="isOver">{{ $t('cloud.noMore') }}</div>
      </div>
      <div class="file-default" v-if="!loading && shareList.length == 0">
        <img :src="$utils.getPng('web4/file_default')" />
        <div class="search"  v-if="shareParams.keywords==''">
          <span>{{ $t('share.notShareFiles') }}</span><span>{{ $t('share.shareLook') }}</span>
        </div>
        <div class="search" v-else>
          <span>{{ $t('cloud.notFile') }}</span><span>{{ $t('cloud.trySearchOther') }}</span>
        </div>
      </div>
    </div>
    <ShareDialog
      boxType="2"
      :shareUrl="shareUrl"
      :handleItem="handleItem"
      :isShow="isShowShareDialog"
      :incomeList="incomeList"
      @handleClose="isShowShareDialog = false"
    ></ShareDialog>
    <!-- 取消分享弹框 -->
    <CancelShareTips
      :isShow="isCancelShareTips"
      :cancelTips="cancelTips"
      :deleteHJ="deleteHJ"
      @handleClose="isCancelShareTips = false"
      @confirm="cancelShare"
    >
    </CancelShareTips>
    <!-- 绑定手机1  实名认证2 验证码3-->
    <BindPhone
      :isShow="isShowBindPhone"
      :type="bindType"
      :time="time"
      @getPhoneCode="getPhoneCode"
      @bindPhone="bindPhone"
      @confirmNameAuth="realNameAuth"
      @handleClose="isShowBindPhone = false"
    ></BindPhone>
    <!-- 自定义右键菜单 -->
    <CustomContextMenu
        ref="customMenu"
        :visible="showContextMenu"
        :x="menuPosition.x"
        :y="menuPosition.y"
        :selected-item="selectedItem"
        @action="handleMenuAction"
        @close="closeMenu"
      />
    <div class="toTop-div" v-show="showTop" @click="scrollToTop">
      <svg-btn icon-class="icon-toTop" style="width: 24px;height: 24px;"></svg-btn>
    </div>
  </div>
</template>

<script>
import {
  shareSetInfo,
  shareNewList,
  cancelNewShare,
} from "@/utils/apiList/share";
import {
  bindPhoneSendCode,
  bindPhoneAPI,
  realNameAuth,
} from "@/utils/apiList/account";
import TabList from "../TabList/index.vue";
import CancelShareTips from "@/components/Cloud/CancelShareTips";
import ShareDialog from "@/components/Cloud/ShareDialog";
import BindPhone from "@/components/Cloud/BindPhone";
import CustomContextMenu from "@/components/CustomContextMenu/index.vue";
export default {
  components: {
    TabList,
    CancelShareTips,
    ShareDialog,
    BindPhone,
    CustomContextMenu,
  },
  data() {
    return {
      fileType: [
        { id: 0, name: "cloud.all" },
        { id: 1, name: "cloud.package" },
        { id: 2, name: "cloud.medium" },
        { id: 3, name: "cloud.document" },
        { id: 4, name: "cloud.picture" },
      ],
      fileTypeId: 0,
      screenList: [
        { id: 6, id1: 7, name: "按浏览量排序" },
        { id: 4, id1: 5, name: "按下载量排序" },
        { id: 2, id1: 3, name: "按大小排序" },
        { id: 0, id1: 1, name: "按时间排序" },
      ],
      screenId: 0,
      shareList: [], //分享列表
      allCheck: 0,
      checkedShares: [], //已选的分享数据
      total: 0,
      loading: true,
      shareParams: {
        //查询分享列表参数
        time: 1,//时间排序 时间排序1倒叙，0升序 默认1
        size: "",//大小排序 大小排序1倒叙，0升序 默认1
        file_views:'',//浏览量选中则为 1 
        file_downs:'',//下载量 选中则为 1
        limit: 60,
        keywords: "",
        page: 0,
        type: 0, //类型 0-全部 1-压缩包 2-视频 3-文档 4-图片 5-音频
      },
      boxType: false,
      handleItem: {}, //当前操作项
      isOver: false,
      showTop: false,
      shareUrl: "",
      isCancelShareTips: false,
      cancelTips: "",
      cancelParams: [],
      isShowShareDialog: false,
      isShowBindPhone: false,
      bindType: 1, //
      msgid: "", //验证码id
      isbindphone: "", //是否绑定手机号
      timerA: null,
      time: 60,
      startX: 0,
      startY: 0,
      selectionBox: {
        left: 0,
        top: 0,
        width: 0,
        height: 0,
      },
      moveBox: {
        left: 0,
        top: 0,
      },
      mouseDownIsCheck: false,
      isLoading2: false,
      list1: [
        { id: 1, name: "setPage.View" },
        { id: 0, name: "share.copyLink" },
        { id: -1, name: "" },
        { id: 3, name: "share.viewLink" },
        { id: -1, name: "" },
      ],
      showFlag: 0,
      isSelecting: 0,
      isOpen: false,
      isOpen2: true,
      isSelectMore: false,
      deleteHJ: false,
      order: false,
      dropdown: ['contextmenu'],
      phone_item: {
        phone: "",
        pcode: "",
      },
      incomeList:[],
      hoverIndex:'',//判断鼠标移入了哪个index
      showContextMenu: false,
      menuPosition: { x: 0, y: 0 },
      selectedItem: [
        {
          id:2,
          name:'cloud.Refresh'
        },
      ]
    };
  },
  created() {
    this.getShareList(1);
  },
  mounted() {
    this.$store.commit("setAttr", {
      name: "endSelectFuncallback",
      val: this.endSelectFun,
    });
  },
  watch: {
    checkedShares: {
      handler(newval, oldVal) {
        if (newval.length > 0 && newval.length < this.shareList.length) {
          this.allCheck = 1;
        } else if (newval.length == 0) {
          this.allCheck = 0;
        } else if (newval.length == this.shareList.length) {
          this.allCheck = 2;
        }
      },
      immediate: true,
    },
    pageValue(newVal) {
      if (newVal == 1) {
        this.cancelCheckedVal();
        this.scrollToTop();
      }
    },
  },
  methods: {
    showMenu(event){
      event.preventDefault(); // 阻止默认行为
      event.stopPropagation(); // 阻止事件冒泡
      
      const forbiddenSelectors = [
        '.file-item-hover',
        '.ant-dropdown',
        '.ant-dropdown-menu',
        '.ant-menu'
      ];
      const isForbidden = event.target.closest(forbiddenSelectors.join(','));
      if (isForbidden) {
        this.closeMenu();
        return;
      }
      this.cancelCheckedVal()
      // 获取菜单的实际尺寸
      const menuSize = this.$refs.customMenu.getMenuSize();
      const menuWidth = menuSize.width;
      const menuHeight = menuSize.height;

      // 获取视口尺寸
      const viewportWidth = document.documentElement.clientWidth;
      const viewportHeight = document.documentElement.clientHeight;

      // 动态调整菜单位置
      let x = event.clientX;
      let y = event.clientY-50;

      // 判断是否靠近窗口右侧
      if (x + menuWidth > viewportWidth) {
        x = event.clientX - menuWidth;
      }
      // 判断是否靠近窗口底部
      if (y + menuHeight > viewportHeight - 110) {
        y = event.clientY - 100;
      }
      // 设置菜单位置
      this.menuPosition = {
        x: x,
        y: y,
      };

      // 显示菜单
      this.showContextMenu = true;
    },
    closeMenu() {
      this.showContextMenu = false
    },
    handleMenuAction(action) {
      switch(action) {
        case 2:
          this.refresh()
          break
      }
    },
    setNav(item) {
      this.$router.push({
        path: item.url,
      });
    },
    chageClass(id) {
      this.fileTypeId = id;
      this.shareParams.type = id;
      this.shareParams.page = 0;
      this.checkedShares = [];
      this.getShareList(1);
    },
    //排序
    changeSort(id) {
      this.screenId = id;
      this.checkedShares = [];
      switch (id) {
        case 0:
          this.shareParams.time = 1;
          this.shareParams.size = "";
          this.shareParams.file_views = "";
          this.shareParams.file_downs = "";
          break;
        case 1:
          this.shareParams.time = 0;
          this.shareParams.size = "";
          this.shareParams.file_views = "";
          this.shareParams.file_downs = "";
          break;
        case 2:
          this.shareParams.size = 1;
          this.shareParams.time = "";
          this.shareParams.file_views = "";
          this.shareParams.file_downs = "";
          break;
        case 3:
          this.shareParams.size = 0;
          this.shareParams.time = "";
          this.shareParams.file_views = "";
          this.shareParams.file_downs = "";
          break;
        case 4:
          this.shareParams.file_downs = 1;
          this.shareParams.time = "";
          this.shareParams.size = "";
          this.shareParams.file_views = "";
          break;
        case 5:
          this.shareParams.file_downs = 0;
          this.shareParams.time = "";
          this.shareParams.size = "";
          this.shareParams.file_views = "";
          break;
        case 6:
          this.shareParams.file_views = 1;
          this.shareParams.time = "";
          this.shareParams.size = "";
          this.shareParams.file_downs = "";
          break;
        case 7:
          this.shareParams.file_views = 0;
          this.shareParams.time = "";
          this.shareParams.size = "";
          this.shareParams.file_downs = "";
          break;
        default:
          break;
      }
      this.shareParams.page = 0;
      this.getShareList(1);
    },
    //搜索
    searchList(value) {
      this.shareParams.keywords = value;
      this.checkedShares = [];
      this.getShareList(1);
    },
    getShareList: _.debounce(
      function (type = 0) {
        if (type == 1) {
          this.shareParams.page = 0;
          this.isLoading2 = false;
          this.loading = true;
        } else {
          if (this.isOver) return;
          this.isLoading2 = true;
          this.loading = false;
        }
        this.isOver = false;
        this.shareParams.page += 1;
        shareNewList(this.shareParams)
          .then((res) => {
            if (res.status == "1") {
              this.loading = false;
              this.isLoading2 = false;
              this.total = res.data.total;
              if (res.data.list.length < this.shareParams.limit)
                this.isOver = true;
              res.data.list.forEach((item, index) => {
                item.isHover = false;
                item.showPlay = true;
              });
              if (this.shareParams.page == 1) {
                this.shareList = res.data.list;
              } else {
                this.shareList = this.shareList.concat(res.data.list);
              }
              if (
                this.checkedShares.length > 0 &&
                this.checkedShares.length < this.shareList.length
              ) {
                this.allCheck = 1;
              } else if (this.checkedShares.length == 0) {
                this.allCheck = 0;
              } else if (this.checkedShares.length == this.shareList.length) {
                this.allCheck = 2;
              }
              this.dropdown = ['contextmenu']
            }
          })
          .catch((err) => {});
      },
      300,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),
    //下拉框出现/隐藏时触发
    changeVisible(e, item) {
      item.isHover = e;
    },
    //更多 操作 a单选取消分享
    handleCommand(command, item) {
      this.handleItem = item;
      this.isCancelShare(command);
    },
    // 单个点击选中
    chooseShare(index) {
      // 点击文件选中
      var exist = this.checkedShares.indexOf(index);
      if (exist == -1) {
        this.checkedShares.push(index);
      } else {
        this.checkedShares.splice(exist, 1);
      }
    },
    // 全选
    setCheckedVal() {
      // 点击文件选中
      this.checkedShares = [];
      var tmpfiles = this.shareList;
      for (var i = 0, len = tmpfiles.length; i < len; i++) {
        this.checkedShares.push(i);
      }
      this.allCheck = 1;
    },
    // 取消全选
    cancelCheckedVal() {
      this.allCheck = 0;
      this.checkedShares = [];
    },
    // 获取选中的文件的id
    getSelFileIds() {
      var ids = [];
      this.checkedShares.map((item) => {
        ids.push(this.shareList[item].file_id);
      });
      return this.$utils.arrFilter(ids);
    },
    isCancelShare(row) {
      this.deleteHJ = '取消分享'
      this.cancelTips = '其他用户将无法通过当前链接接收此文件'
      //多选
      if (this.checkedShares.length > 0) {

        //如果选中了某一项，且悬浮了其他项进行取消操作
        if(row){
          this.cancelParams = [this.handleItem.file_id]
        }else{
          this.cancelParams = this.getSelFileIds();
        }
      }else{
        this.cancelParams = [this.handleItem.file_id]
      }
      this.isCancelShareTips = true;
    },
    //取消分享
    cancelShare() {
      cancelNewShare({
        f_ids:this.cancelParams.join(','),
        type:2, //0-删除合集 1-恢复合集 2-彻底删除
      })
        .then((res) => {
          if (res.status == "1") {
            this.isCancelShareTips = false;
            this.$toast(res.msg, 1);
            this.checkedShares = [];
            this.getShareList(1);
          } else {
            this.$toast(res.msg, 2);
          }
        })
        .catch((err) => {});
    },
    //查看文件
    viewUrl(item){
      //已锁定的不能跳转查看
      if(item.is_locked == '1'){
        return
      }
      window.open(item.share_link,'_blank');
    },
    //复制链接
    copyUrl(item) {
      if (this.$store.state.userInfo.phone == "") {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      let msg =
        item.good_count == 1 ? "复制链接及取件码成功" : "复制链接成功";
      this.$copyText(item.share_link).then(
        (e) => {
          this.$toast(msg, 1);
        },
        function (e) {}
      );
    },
    //分享 列表打开分享弹框
    openShareBox(item) {
      if (this.$store.state.userInfo.phone == "") {
        this.bindType = 1;
        this.isShowBindPhone = true;
        return;
      }
      this.handleItem = item;
      this.shareUrl = item.share_link;
      this.boxType = false;
      this.openShareDialog1()
    },
    openShareDialog1() { 
      shareSetInfo({ file_id: this.handleItem.file_id }).then((res) => {
          if (res.status == "1") {
            this.shareUrl = this.handleItem.share_link;
            this.boxType = '2';
            this.isShowShareDialog = true;
            this.incomeList = res.data.rebate_model;
          }else{
            this.$toast(res.msg,2)
          }
        });
    },
    
    scrollBoxFun() {
      var scrollEl = this.$refs.scrollBox;
      this.showTop = scrollEl.scrollTop > 50;
      let list = document.getElementsByClassName("el-tooltip__popper");
      let list1 = document.getElementsByClassName("el-dropdown-menu");
      if (list.length > 0) {
        list[list.length - 1].style.display = "none";
      }
      if(list1.length > 0){
        list1[list1.length - 1].style.display = "none";
      }
      //滚动关闭右键菜单
      if(this.showContextMenu){
        this.showContextMenu = false
      }
    },
    scrollToTop() {
      let scrollEl = this.$refs.scrollBox;
      scrollEl.scrollTop = 0;
    },
  
    getPhoneAly(captcha_verify) {
      return new Promise((resolve) => {
        bindPhoneSendCode({
          phone: this.phone_item.phone,
          pcode: this.phone_item.pcode,
          captcha_verify: captcha_verify || "",
        }).then((res) => {
          if (res.status == "1") {
            resolve({
              result: true,
              validate: true,
            });
            this.$toast(res.msg, 1);
            this.msgid = res.data.msgid;
            this.bindType = 3;
            this.timerA = setInterval(() => {
              this.minute();
            }, 1000);
          } else if (res.status == 90001) {
            resolve({
                  result: false,
                  validate: false
                })
              this.$toast(res.msg, 2);
            this.$AliCode.handleOpen(this.getPhoneAly);
          } else {
            resolve({
              result: true,
              validate: true,
            });
            this.$toast(res.msg, 2);
          }
        });
      });
    },
    //发送验证码
    getPhoneCode(phone, pcode) {
      this.phone_item = {
        phone,
        pcode,
      };
      // var reg_tel =
      //   /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // if (!reg_tel.test(phone)) {
      //     this.$toast("请正确输入手机号", 3);
      //     return true
      // }
      this.getPhoneAly();
    },
    minute() {
      this.time = this.time - 1;
      if (this.time == 0) {
        this.time = 60;
        clearInterval(this.timerA);
      }
    },
    bindPhone(data) {
      let params = { msgid: this.msgid, ...data };
      bindPhoneAPI(params).then((res) => {
        if (res.status == "1") {
          this.isShowBindPhone = false;
          this.$store.commit("getuserVuex");
          this.$toast(res.msg, 1);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    //实名
    realNameAuth(data) {
      realNameAuth(data).then((res) => {
        if (res.status == "1") {
          this.isShowBindPhone = false;
          this.$store.commit("getuserVuex");
          this.$toast(res.msg, 1);
        } else {
          this.$toast(res.msg, 2);
        }
      });
    },
    handleMouseDown: _.debounce(
      function (event, index) {
        if(index == -1){
          this.checkedShares = []
        }
        this.selectionBox = {
          left: 0,
          top: 0,
          width: 0,
          height: 0,
        };

        this.startX = event.clientX;
        this.startY = event.clientY;

        const currentX = event.clientX;
        const currentY = event.clientY;
        this.moveBox = {
          left: 0,
          top: 0,
        };
        // 检查触发事件的元素是否是 file-item-hover 的父元素
        if (event.button == 0) {
          let arr = ['icon_checks','iconColor']
          if (!arr.includes(event.target.classList[0])) {
            //点击icon_checks 即左侧选中多选不触发handleMouseDown 只触发chooseFile
            // 执行你的 mousedown 逻辑
            this.selectItemOne(index);
            this.moveBox = {
              left: currentX,
              top: currentY - 56,
            };
          }
          this.isOpen = false;
        } else if (event.button == 1) {
        } else if (event.button == 2) {
          // this.checkedShares = [];
          if(index == -1) return;
          var exist = this.checkedShares.indexOf(index);
          if (exist == -1) {
            this.checkedShares = [];
            this.checkedShares.push(index);
          } else {
            // this.checkedShares.splice(exist, 1);
          }
          if (this.checkedShares.length > 1) {
            this.isSelectMore = true;
          } else {
            this.isSelectMore = false;
          }
        }
      },
      100,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),

    handleMouseenter(event, index) {
      this.hoverIndex = index
    },
    handleMouseleave(event, index){
      this.hoverIndex = ''
    },
    chooseFile(index) {
      // 点击文件选中
      var exist = this.checkedShares.indexOf(index);
      if (exist == -1) {
        this.checkedShares.push(index);
      } else {
        this.checkedShares.splice(exist, 1);
      }
    },

    selectItemOne(index) {
      if (index == -1) {
        this.isSelecting = 1;
        return;
      }
      // 点击文件选中
      var exist = this.checkedShares.indexOf(index);
      if (exist == -1) {
        this.checkedShares = [];
        this.checkedShares.push(index);
        this.isSelecting = 1;
      } else {
        // this.checkedShares.splice(exist, 1);
      }
    },
    selectItems: _.debounce(
      function (event) {
        const currentX = event.clientX;
        const currentY = event.clientY;

        // 计算选择框的位置和大小
        const minX = Math.min(this.startX, currentX);
        const minY = Math.min(this.startY, currentY);
        const maxX = Math.max(this.startX, currentX);
        const maxY = Math.max(this.startY, currentY);
        this.selectionBox = {
          left: minX,
          top: minY - 56,
          width: maxX - minX,
          height: maxY - minY,
        };
        if (this.isSelecting == 1) {
          // 遍历可选择项，判断是否在选择框内并选中
          this.shareList.forEach((item, index) => {
            const itemElement = document.querySelector(
              `.file-item-hover:nth-child(${this.shareList.indexOf(item) + 1})`
            );
            const itemRect = itemElement.getBoundingClientRect();
            if (itemRect.top > minY - 56 && itemRect.bottom < maxY + 69) {
              if (!this.checkedShares.includes(index)) {
                this.checkedShares.push(index);
              }
              this.showFlag = 1;
            } else {
              const index = this.checkedShares.indexOf(index);
              if (index !== -1) {
                this.checkedShares.splice(index, 1);
              }
            }
          });
        }
      },
      0,
      {
        leading: true, //指定在延迟开始前调用
        trailing: false, //指定在延迟结束后调用
      }
    ),

    endSelection() {
      this.showFlag = 0;
    },
    endSelectFun() {
      this.isSelecting = 0;
      this.checkStr = "";
      this.showFlag = 0;
      this.$store.commit("setAttr", {
        name: "showFlag",
        val: 0,
      });
      this.$store.commit("setAttr", {
        name: "check_str",
        val: "",
      });
    },
    resetRouter() {
      this.shareParams={
        //查询分享列表参数
        time: 1,//时间排序 时间排序1倒叙，0升序 默认1
        size: "",//大小排序 大小排序1倒叙，0升序 默认1
        file_views:"",//浏览量选中则为 1 
        file_downs:"",//下载量 选中则为 1
        limit: 60,
        keywords: "",
        page: 0,
        type: 0, //类型 0-全部 1-压缩包 2-视频 3-文档 4-图片 5-音频
      },
      this.screenId = 0
      this.checkedShares=[]
      this.fileTypeId=0
      this.$refs.tabList.keyword = "";
      this.getShareList(1);
    },
    refresh() {
      this.shareParams.page = 0;
      this.checkedShares = [];
      this.getShareList(1);
    },
    rightHandle(id, item) {
      this.visibleChange(false);
      switch (id) {
        case 0:
          this.copyUrl(item);
          break;
        case 1:
          this.viewUrl(item);
          break;
        case 2:
          break;
        case 3:
          this.openShareBox(item);
          break;
        case 4:
          break;
        case 5:
          break;
        case 6:
          this.isCancelShare();
          break;
        default:
          break;
      }
    },
    visibleChange(e) {
      if(e){
        this.dropdown = ['contextmenu','click']
        this.isOpen = e;
        this.isOpen2 = true
      } else {
        this.isOpen2 = false
        this.dropdown = ['contextmenu']
      }
    },
    onError(e, item) {
      this.$set(item, "showPlay", false);
    },
  },
  computed: {
    pageValue() {
      return this.shareParams.page;
    },
  },
};
</script>

<style lang="scss" scoped>
.file-type{
  padding: 0;
  margin-top: 0;
}
.file-content{
  margin-top: 124px;
  // margin-top: 160px;
  height: calc(100vh - 185px);
}
</style>
